<template>
  <div>
    <detector
      v-for="detector in agentDetectors"
      :key="detector.name"
      :data="detector"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Detector from '@/components/material/Detector'

export default {
  components: {
    Detector
  },
  props: {
    detectors: Array
  },
  computed: {
    ...mapGetters(['agentDetectors'])
  }
}
</script>

<style>
</style>
